export type DisplayConfig = {
  fileIconClass: string;
  cardBorderClass: string;
  showDownload: boolean;
  showReplace: boolean;
  showDelete: boolean;
  showVerify: boolean;
  showRetry: boolean;
  replaceButtonColor?: "secondary" | "critical";
};

const NEUTRAL_CARD: Pick<DisplayConfig, "fileIconClass" | "cardBorderClass"> = {
  fileIconClass: "text-secondary-900",
  cardBorderClass: "border-secondary-500 hover:border-secondary-600 hover:bg-secondary-25",
};

const CAUTION_CARD: Pick<DisplayConfig, "fileIconClass" | "cardBorderClass"> = {
  fileIconClass: "text-caution-600",
  cardBorderClass: "border-secondary-500 hover:border-secondary-600 hover:bg-secondary-25",
};

const CRITICAL_CARD: Pick<DisplayConfig, "fileIconClass" | "cardBorderClass"> = {
  fileIconClass: "text-critical-600",
  cardBorderClass: "border-critical-500 hover:border-critical-600 hover:bg-critical-50",
};

export function getDisplayConfig(lifecycleStatus: string | undefined): DisplayConfig | null {
  if (!lifecycleStatus) return null;

  switch (lifecycleStatus) {
    case "required":
      return {
        ...CRITICAL_CARD,
        showDownload: false,
        showReplace: false,
        showDelete: true,
        showVerify: true,
        showRetry: false,
      };
    case "in_progress":
      return {
        ...CAUTION_CARD,
        fileIconClass: "text-caution-600",
        showDownload: true,
        showReplace: false,
        showDelete: false,
        showVerify: false,
        showRetry: false,
      };
    case "rejected":
      return {
        ...CRITICAL_CARD,
        showDownload: false,
        showReplace: true,
        showDelete: false,
        showVerify: false,
        showRetry: false,
        replaceButtonColor: "critical",
      };
    case "failed":
      return {
        ...CRITICAL_CARD,
        showDownload: false,
        showReplace: false,
        showDelete: true,
        showVerify: false,
        showRetry: true,
      };
    case "approved":
      return {
        ...NEUTRAL_CARD,
        showDownload: true,
        showReplace: true,
        showDelete: true,
        showVerify: false,
        showRetry: false,
        replaceButtonColor: "secondary",
      };
    case "expiring_soon":
      return {
        ...CAUTION_CARD,
        fileIconClass: "text-caution-600",
        showDownload: true,
        showReplace: true,
        showDelete: true,
        showVerify: false,
        showRetry: false,
        replaceButtonColor: "secondary",
      };
    case "expired":
      return {
        ...CRITICAL_CARD,
        showDownload: false,
        showReplace: true,
        showDelete: true,
        showVerify: false,
        showRetry: false,
        replaceButtonColor: "critical",
      };
    default:
      return null;
  }
}
